/* The site is usable if this optional film cannot start; never hold navigation for a video. */
(() => {
  const root = document.documentElement;
  const intro = document.querySelector('[data-cr-intro]');
  if (!intro || !root.classList.contains('cr-intro-pending')) return;
  const video = intro.querySelector('[data-cr-intro-video]');
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  let closing = false;
  let startTimeout;
  let safetyTimeout;
  const finish = (immediate = false) => {
    if (closing) return;
    closing = true;
    clearTimeout(startTimeout);
    clearTimeout(safetyTimeout);
    video.pause();
    root.classList.remove('cr-intro-pending');
    intro.classList.add('is-leaving');
    document.dispatchEvent(new CustomEvent('clown:intro:end'));
    const close = () => { intro.close(); intro.remove(); };
    if (immediate || reduced.matches) close();
    else setTimeout(close, 560);
  };
  intro.addEventListener('cancel', event => { event.preventDefault(); finish(); });
  video.addEventListener('error', () => finish(true), { once: true });
  video.addEventListener('ended', () => finish(), { once: true });
  // The source ends on the URL. Reveal the homepage once the official logo has formed.
  video.addEventListener('timeupdate', () => { if (video.currentTime >= 3.45) finish(); });
  video.addEventListener('playing', () => clearTimeout(startTimeout), { once: true });
  reduced.addEventListener('change', () => { if (reduced.matches) finish(true); });
  window.addEventListener('pageshow', event => { if (event.persisted) finish(true); });
  document.addEventListener('visibilitychange', () => { if (document.hidden) finish(true); });
  try {
    intro.showModal();
    video.muted = true;
    video.src = video.dataset.src;
    startTimeout = setTimeout(() => finish(true), 2200);
    safetyTimeout = setTimeout(() => finish(true), 6500);
    video.play()?.catch(() => finish(true));
  } catch (_) { finish(true); }
})();
